//src/modules/analytics/Analytics.tsx
import React from 'react';

export const Analytics: React.FC = () => {
  return (
    <div>
      <h1>Аналитика</h1>
      <p>Компонент в разработке</p>
    </div>
  );
};